const messages = {
  applyTo: {
    label: {
      id: 'admin/promotions.form.shipping-variant-selector.apply-to.label',
    },
    all: {
      id: 'admin/promotions.form.shipping-variant-selector.apply-to.all',
    },
    cheapest: {
      id: 'admin/promotions.form.shipping-variant-selector.apply-to.cheapest',
    },
    selected: {
      id: 'admin/promotions.form.shipping-variant-selector.apply-to.selected',
    },
  },
  validation: {
    required: { id: 'admin/promotions.form.validation.required' },
  },
  view: {
    cheapest: {
      id: 'admin/promotions.form.buy-and-win.benefit.free-shipping.content.cheapest',
    },
    selected: {
      id: 'admin/promotions.form.buy-and-win.benefit.free-shipping.content.selected',
    },
  },
}

export default messages
